import React from 'react';
import EntidadeAutocomplete from './EntidadeAutocomplete';

const CamposAtivo = ({ ativoSelecionado, onChangeAtivo }) => (
  <EntidadeAutocomplete
    tipo="A"
    label="Ativo"
    placeholder="Digite código ou nome..."
    entidadeSelecionada={ativoSelecionado}
    onChangeEntidade={onChangeAtivo}
  />
);

export default CamposAtivo;
